import { useContext } from 'react';
import { ClubContext } from 'src/contexts/ClubContext';

// ----------------------------------------------------------------------

const useClub = () => useContext(ClubContext);

export default useClub;
